import {
  QueryResult,
  QueryTuple,
  gql,
  useLazyQuery,
  useQuery,
} from '@apollo/client';
import { UserType } from '@cnx-saas/common';
import { USER_FRAGMENT } from '../fragments/user-fragment';

const GET_ME_QUERY = gql`
  query {
    getMe {
      ...User
    }
  }
  ${USER_FRAGMENT}
`;

interface GetMeOutput {
  getMe: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    language: string;
    userType: UserType;
  };
}

function useGetMeQuery(): QueryResult<GetMeOutput> {
  return useQuery<GetMeOutput>(GET_ME_QUERY);
}

function useGetMeLazyQuery(): QueryTuple<
  GetMeOutput,
  {
    [x: string]: unknown;
  }
> {
  return useLazyQuery<GetMeOutput>(GET_ME_QUERY);
}

export type { GetMeOutput };
export { useGetMeQuery, useGetMeLazyQuery };
